/*
 * Copyright (c) 2026
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RestResponse } from '../model';
import { ApiHeaders } from './headers';
import { Holiday } from '../model/holiday';

@Injectable()
export class HolidayProvider {

  constructor(private http: HttpClient) {}

  getHolidays(page: number, query?: string): Observable<RestResponse> {
    return this.http.post<RestResponse>(
      `${environment.API_URL}/api/holiday/list?page=${page}` +
      (query ? '&query=' + encodeURIComponent(query) : ''),
      null,
      ApiHeaders.getOptions());
  }

  saveHoliday(holiday: Holiday): Observable<RestResponse> {
    return this.http.post<RestResponse>(
      `${environment.API_URL}/api/holiday`, holiday, ApiHeaders.getOptions());
  }

  deleteHoliday(holiday: Holiday): Observable<RestResponse> {
    return this.http.post<RestResponse>(
      `${environment.API_URL}/api/holiday/${holiday.ID}/delete`, null, ApiHeaders.getOptions());
  }

  /** Resolved concrete holiday dates that feed the business-day calculations. */
  getDates(): Observable<RestResponse> {
    return this.http.get<RestResponse>(
      `${environment.API_URL}/api/holiday/dates`, ApiHeaders.getOptions());
  }
}
